import React, { useEffect, useState } from 'react';
import DynamicForm, { withExtension } from 'components/Shared/DynamicForm';
import ViewButton from 'components/Inspections/ViewIterationButton';
import { getInspectionReports } from 'utils/InspectionsUtils';
import { Field, Schema } from 'utils/SchemaUtils';
import { useFormContext } from 'hooks/useFormContext';
import {  FormProvider } from 'context/FormContext';
import CenteredCircularProgress from 'components/Shared/CenteredCircularProgress';



const ViewInspectionsCard = ({ inspection }) => {
    const { InspectionId: inspectionId } = inspection;

    const [refreshForm, setRefreshForm] = useState(new Date());
    const [inspectionReports, setInspectionReport] = useState({ ready: false, data: [] });

    const { updateSchema, ready, schema } = useFormContext();


    useEffect(() => {
        let mounted = true;
        const asyncEffects = async () => {
            console.log(inspectionId)
            const _inspectionReports = await getInspectionReports(inspectionId);
            // set data;
            mounted && setInspectionReport({ ready: true, data: _inspectionReports });
        };
        // reset to loader;
        mounted && setInspectionReport({ ready: false, data: [] });
        asyncEffects();
        return () => { mounted = false };
    }, [inspectionId, refreshForm]);


    useEffect(() => {
        
        const sortReports = (reports) => {
            return reports.data.sort((a, b) => new Date(b.date) - new Date(a.date)).map(r => `${r.isSigned ? 'FINAL' : 'DRAFT'} - ${new Date(r.date).toLocaleString()}`)
        };
        const reviewInspSchema = new Schema("View Revisions");
        const revisions = inspectionReports.data.length > 0 ? sortReports(inspectionReports) : ["NO REVISIONS FOUND"];
        reviewInspSchema.addField(new Field({ fieldName: "Revisions", label: "Revisions", type: 'string', enumValues: revisions }));
        updateSchema(reviewInspSchema);
        return () => updateSchema({})
    }, [inspectionReports, updateSchema]);



    const Form = () => withExtension(DynamicForm,
        {
            schema: schema,
            disabledProperties: ["User"],
            onSubmit: async (e) => {
                return { success: true }
            },
            inputVariant: "standard",
            fieldDecorators: {
                Revisions: {
                    component: <ViewButton inspectionReports={inspectionReports} />,
                    size: 3
                }
            },
            title: true,
            hideActions: true
        }
    )

    return (ready && inspectionReports.ready ? <Form /> : <CenteredCircularProgress />);
}

const WrappedViewInspectionsCard = (props) => (
    <FormProvider><ViewInspectionsCard {...props} /></FormProvider>
)

export default WrappedViewInspectionsCard;